import styled from 'styled-components';
import { color, spacing } from 'theme';

export const StyledSection = styled.div`
  background-color: ${color('midnight_900')};
  color: ${color('text_default_inverse')};
  padding-bottom: ${spacing('xs2')};
`;
